<template>
    <div class="content">
        <span class="title">{{ $t("message.browser_title") }}</span>
          <span class="description" v-html='$t("message.browser_description")'></span>
        <br>
        <span class="step">{{ $t("message.browser_step1") }}</span>
        <div>
            <img class="guide-image" src="./../images/step1.jpg" alt="Secret Vault private browser step 1 tutorial screenshot"/>

                <span class="guide-text">{{ $t("message.browser_step1_tip") }}</span>

        </div>
        <!-- <span class="step">{{ $t("message.browser_step2") }}</span>
        <div>
            <img class="guide-image" src="./../images/step2.jpg"/>
            <div class="text-container" style="top: -450px;">
                <span class="guide-text">{{ $t("message.browser_step2_tip") }}</span>
            </div>
        </div> -->
    </div>
</template>

<script type="text/javascript">
  export default {
    data() {
      return {
        title: 'browser'
      }
    }
  }
</script>

<style scoped lang="scss">
    body {

    }
    .content {
        padding: 20px;
        margin: 0 auto;
        max-width: 400px;
    }
    .title {
        color: #333;
        font-weight: bold;
        font-size: 26px;
        line-height: 40px;
        display: block;
    }

    .description {
        color: #666 ;
        font-size: 16px;
        line-height: 20px;
        display: block;
    }
    .step {
        font-weight: bold;
        color: #333;
    }
    .text-container {
        float:left;
        position: relative;
        left: 50%;
        width: 375px;
    }
    .guide-image {
        width: 100%;
        max-width: 400px;
        margin: 10px 0 20px;
    }
    .guide-text {
        position: absolute;
        max-width: 360px;
        height: 140px;
        top: 320px;
        padding: 0 20px;
        display: block;
        width: 100%;
        text-align: center;
        color: red;
        font-size: 30px;
        text-shadow: 2px 2px 5px white;
    }
</style>